import { api } from "@/lib/api";

export const DOC_TYPES = {
  TAPU: "Tapu",
  KIMLIK: "Kimlik",
  KIRA_SOZLESMESI: "Kira Sözleşmesi",
  SATIS_SOZLESMESI: "Satış Sözleşmesi",
  VEKALETNAME: "Vekaletname",
  DEKONT: "Dekont",
  DIGER: "Diğer",
};

export const SCAN_MODES = {
  SHADOW_FREE: "Gölgesiz (önerilen)",
  BW: "Siyah-beyaz belge",
  ORIGINAL: "Orijinal renk",
};

export const blobUrl = async (url) => URL.createObjectURL((await api.get(url, { responseType: "blob" })).data);

export const openPdf = async (id) => {
  const win = window.open("", "_blank");
  try {
    win.location.href = await blobUrl(`/scans/${id}/pdf`);
  } catch {
    win?.close();
  }
};
